import React from "react";
import { ProgressCircle } from "./spectrumCompat";

/**
 * Full-screen loading overlay (S2 ProgressCircle — react-spectrum.adobe.com/ProgressCircle).
 */
function FullScreenLoader() {
  return (
    <div className="dxp-fullscreen-loader">
      <ProgressCircle aria-label="Loading" isIndeterminate size="L" />
    </div>
  );
}

export default FullScreenLoader;
